import Highlight from './Highlight';
import Strikethrough from './Strikethrough';
import Code from './Code';
import Underline from './Underline';
import {
  objectInputRules,
  objectKeyMaps,
  objectParsers,
  objectSchemas,
  objectSerializers,
} from '../helper/prosemirrorObjects';
import {schema as markdownSchema} from 'prosemirror-markdown';
import Label from './Label';
import RelativeTime from './RelativeTime';

const marks = [
    new Highlight(),
    new Strikethrough(),
    new Code(),
    new Underline(),
    new Label(),
    new RelativeTime()
];

const markSchemaSpecs = markdownSchema.spec.marks
    .append(objectSchemas(marks))
    .update("link", {
        ...markdownSchema.spec.marks.get("link"),
        attrs: {
            ['data-id']: {default: null},
            ['data-size']: {default: null},
            ['data-type']: {default: null},
            color: {default: null},
            error: {default: false},
            href: {},
            title: {default: null},
            button: {default: false}
        },
        parseDOM: [{
            tag: "a[href]", getAttrs: function getAttrs(dom) {
                return {
                    ['data-id']: dom.getAttribute("data-id"),
                    ['data-size']: dom.getAttribute("data-size"),
                    ['data-type']: dom.getAttribute("data-type"),
                    color: dom.getAttribute("data-color"),
                    error: dom.hasAttribute("error"),
                    href: dom.getAttribute("href"),
                    title: dom.getAttribute("title"),
                    button: dom.getAttribute("class")?.includes("button")
                }
            }
        }]
    });

const markParsers = objectParsers(marks);
const markSerializers = objectSerializers(marks);
const markKeyMaps = schema => objectKeyMaps(marks, schema);
const markInputRules = schema => objectInputRules(marks, schema);

export {marks, markSchemaSpecs, markParsers, markSerializers, markKeyMaps, markInputRules};